import script from "./PrivacyVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyVideo.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyVideo.vue?vue&type=style&index=0&id=a40133cc&scoped=true&lang=css"

import exportComponent from "../../../../../../../../Documents/GitHub/bankari reality/urbo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a40133cc"]])

export default __exports__